function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";
import bulletsConfig from "segments/desktop/core-components/bullets/default-props";
import { MD } from "constants/sizes";
import { StyledFullWithBulletsParagraphComponent, FULL_WITH_BULLETS_PARAGRAPH_WRAPPER_MAX_WIDTH } from "./full-with-bullets-paragraph-component.scss";
const FullWithBulletsParagraphComponent = (props)=>{
    const { maxWidth } = props;
    return /*#__PURE__*/ _jsx(StyledFullWithBulletsParagraphComponent, {
        className: "full-with-bullets-paragraph-component",
        children: /*#__PURE__*/ _jsx("div", {
            className: "full-with-bullets-paragraph-wrapper",
            style: {
                maxWidth
            },
            children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, props))
        })
    });
};
FullWithBulletsParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, FullParagraphDefaultProps), {
    bulletsConfig,
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: MD,
    textSize: MD,
    maxWidth: FULL_WITH_BULLETS_PARAGRAPH_WRAPPER_MAX_WIDTH
});
export default FullWithBulletsParagraphComponent;
